var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CouponList',{attrs:{"coupons":_vm.allCoupons,"couponAfterMoney":_vm.couponAfterMoney},on:{"onSelectedCoupons":_vm.onSelectedCoupons}})
}
var staticRenderFns = []

export { render, staticRenderFns }